import React, { useRef } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ReportChart from './Chart';
import Charts from 'components/Charts';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '1100px',
      maxWidth: '1100px',
      maxHeight: '750px',
      height: '750px'
    }
  })
);

interface PastPerformanceReportChartProps {
  data: any;
  earliestDates: any;
  footprints: any;
  name?: string;
  showOverview?: boolean;
  hideLegend?: boolean;
  hideBenchmarks?: boolean;
  height?: number;
}

const PastPerformanceReportChart = ({
  data,
  earliestDates,
  footprints,
  name,
  showOverview = true,
  hideLegend = false,
  hideBenchmarks = false,
  height = 750
}: PastPerformanceReportChartProps) => {
  const chart = useRef(null);
  const classes = useStyles();

  return (
    <ReportChart
      name={name || 's_recommended_portfolio_p10_performance_00'}
      chartElement={chart.current}
    >
      <Grid item xs={12} sm={6} md={6} lg={6} className={classes.wrapper}>
        <Paper>
          <Grid item xs={12} ref={chart}>
            <Charts.IPS.PastPerformance
              isAnimationActive={false}
              data={data}
              earliestDates={earliestDates}
              footprints={footprints}
              height={height}
              bigLabels
              isAnyPolicyAdded={true}
              showOverview={showOverview}
              hideLegend={hideLegend}
              hideBenchmarks={hideBenchmarks}
            />
          </Grid>
        </Paper>
      </Grid>
    </ReportChart>
  );
};

export default PastPerformanceReportChart;
